"use client";

import { c as _c } from "react/compiler-runtime";
import { useSuspenseQuery } from "@apollo/client/react";
import { GET_ACCREDITATIONS } from "@/graphql/queries/accreditations-query";
import Image from "next/image";
import { Text } from "../ui/text";
import { Marquee } from "../ui/marquee";
import { AspectRatio } from "../ui/aspect-ratio";
export const AccreditationMarquee = () => {
  const $ = _c(7);
  const {
    data: accreditationData
  } = useSuspenseQuery(GET_ACCREDITATIONS);
  let t0;
  if ($[0] !== accreditationData?.accreditations) {
    t0 = accreditationData?.accreditations || [];
    $[0] = accreditationData?.accreditations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const accreditations = t0;
  if (accreditations.length === 0) {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="h-20 w-full" />;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="from-background pointer-events-none absolute left-0 z-20 h-full w-24 bg-linear-to-r to-transparent lg:w-48" />;
    t2 = <div className="from-background pointer-events-none absolute right-0 z-20 h-full w-24 bg-linear-to-l to-transparent lg:w-48" />;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== accreditations) {
    t3 = <div className="relative">{t1}{t2}<Marquee pauseOnHover={true} reverse={true} className="animate-marquee-reverse flex w-max items-center [--duration:50s]">{[...accreditations].map(_temp)}</Marquee></div>;
    $[5] = accreditations;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
function _temp(item, idx) {
  return <div key={idx} className="group flex shrink-0 flex-col items-center md:mx-6 lg:mx-8"><div className="dark:bg-primary-foreground mb-2 rounded-md px-1 py-2"><AspectRatio ratio={1.7777777777777777} className="relative h-10 w-32"><Image src={item.logo_url} alt={item.name} fill={true} className="object-contain" fetchPriority="high" priority={true} loading="eager" sizes="128px" quality={50} /></AspectRatio></div><Text className="text-center text-[10px] font-bold tracking-widest text-gray-500 uppercase">{item.name}</Text></div>;
}